import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { incomeOrigins } from 'src/app/@core/constants';
import { ObjectUtils } from 'src/app/@core/utils/object-utils';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';
import { OnbaseService } from 'src/app/services/onbase.service';

@Component({
  selector: 'app-remittance-income',
  templateUrl: './remittance-income.component.html',
  styleUrls: ['./remittance-income.component.sass']
})
export class RemittanceIncomeComponent implements OnInit {

  constructor(private onbaseService: OnbaseService) { }

  @Input() remittanceForm: FormGroup = new FormGroup({
    incomeAmount: new FormControl("", [Validators.min(1), Validators.required]),
    remittanceName: new FormControl("", Validators.required),
    familyRelationship: new FormControl("", Validators.required),
    incomeOrigin: new FormControl("", Validators.required),
    receivingDate: new FormControl("", Validators.required),
  })
  @Input() onbaseCatalogue: OnbaseCatalogue = new OnbaseCatalogue();
  @Input() readonly: boolean = false;
  familyRelationships: Array<{ key: string, value: string }> = [];
  incomeOrigins: Array<{ key: string, value: string }> = [];
  @Input() isShortFormActiveForPlan = false;
  async ngOnInit(): Promise<void> {
    if (this.onbaseCatalogue.economicActivity.length == 0) {
      this.onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
    }
    this.familyRelationships = ObjectUtils.objectToArray(this.onbaseCatalogue.naturalRelation);
    this.incomeOrigins = incomeOrigins;
    this.remittanceForm.get("familyRelationship")?.markAsDirty()
    this.remittanceForm.get("incomeOrigin")?.markAsDirty()
  }

}
